import { Megaphone } from "lucide-react";

export default function AdSlot({ slot = "default", variant = "vertical" }) {
  const isHorizontal = variant === "horizontal";
  return (
    <div
      data-testid={`ad-slot-${slot}`}
      className={`relative overflow-hidden rounded-2xl border border-dashed border-[#27272A] bg-[#121212]/60 ${
        isHorizontal
          ? "px-4 py-2.5 flex items-center gap-3 min-h-[56px]"
          : "p-4 min-h-[220px] flex flex-col items-center justify-center text-center"
      }`}
    >
      <span className="absolute top-1.5 right-2 text-[9px] uppercase tracking-wider text-[#6B7280]">Ad</span>
      <Megaphone className={`text-[#3B82F6] shrink-0 ${isHorizontal ? "h-4 w-4" : "h-5 w-5 mb-2"}`} />
      <div className={`text-xs text-[#9CA3AF] leading-relaxed ${isHorizontal ? "" : "max-w-[220px]"}`}>
        {isHorizontal
          ? "Your ad here — sponsor this slot. NoteLosh takes commission on every click."
          : "Your ad here. Sponsor a slot — NoteLosh takes commission on every click."}
      </div>
      {!isHorizontal && <span className="mt-2 text-[10px] text-[#6B7280]">slot: {slot}</span>}
    </div>
  );
}
